import firebase from 'firebase/index';
import {actionTypes} from 'redux-resource';
import {serializeItem} from './serializers';

export default (resourceName, id) => (
	dispatch => {
		dispatch({
			type: actionTypes.READ_RESOURCES_PENDING,
			resourceName,
			resources: [id]
		});

		return firebase.database()
			.ref(`${resourceName}/${id}`)
			.once('value')
			.then(snapshot => {
				const resources = [serializeItem(snapshot)];

				dispatch({
					type: actionTypes.READ_RESOURCES_SUCCEEDED,
					resourceName,
					resources
				});

				return resources;
			});
	}
);



// WEBPACK FOOTER //
// ./src/client/redux/actions/helpers/read-item.js